import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from '@stdlib/assert/is-nonnegative-integer';
import __var_2__ from '@stdlib/assert/is-nonnegative-integer-array';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var isNonNegativeInteger = __var_1__.isPrimitive;
var isNonNegativeIntegerArray = __var_2__.primitives;


// VARIABLES //

var debug = logger( 'plot:set:x-rug-size' );


// MAIN //

/**
* Sets the x-axis rug tick (tassel) size.
*
* @private
* @param {(NonNegativeInteger|Array<NonNegativeInteger>)} v - size
* @throws {TypeError} must be a nonnegative integer or nonnegative integer array
*/
function set( v ) {
	/* eslint-disable no-invalid-this */
	var isInt = isNonNegativeInteger( v );
	if ( !isInt && !isNonNegativeIntegerArray( v ) ) {
		throw new TypeError( 'invalid value. `xRugSize` must be a nonnegative integer or nonnegative integer array. Value: `' + v + '.`' );
	}
	if ( isInt ) {
		v = [ v ];
	} else {
		v = v.slice();
	}
	debug( 'Current value: %s.', JSON.stringify( this._xRugSize ) );

	this._xRugSize = v;
	debug( 'New Value: %s.', JSON.stringify( this._xRugSize ) );

	this.emit( 'change' );
}


// EXPORTS //
export default set;
